export default __webpack_public_path__ + "static/media/europe.bb05773b.jpg";